import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { useLogout } from '@core/js/hooks/auth';
import { useTranslations } from '@core/js/hooks/i18n';
import { useSmartClosePopups } from '@theme/js/components/common/PopupManager';
import { useConfirmationPopup } from '@core/js/components/common/popups/ConfirmationPopup';
import { showLogoutNotificationPopupAction } from '@core/js/components/popups/LogoutNotificationPopup';
import { useLoginPopup } from '@theme/js/components/popups/LoginPopup';
import { useAppSelector } from '@core/js/store/hooks';
import { prop } from 'ramda';

export const useLegacyLogoutHandler = () => {
    const showConfirmationPopup = useConfirmationPopup();
    const isLoginAgainPopup = useAppSelector(prop('isLoginAgainPopup'));
    const translate = useTranslations('playtech.mobile.system.');
    const logout = useLogout();
    const dispatch = useDispatch();
    const showLoginPopup = useLoginPopup();
    const closePopups = useSmartClosePopups();

    useEffect(() => {
        const invokeLogoutConfirmation = () => {
            showConfirmationPopup({
                content: translate('logoutconfirm.title'),
                /* TotalCasino changes */
                buttons: [
                    {
                        text: translate('logout.button.title'),
                        className: 'fn-accept popup-modal__button_type_decline',
                        onClick: async () => {
                            await logout({ isManual: true });

                            closePopups('logout');

                            isLoginAgainPopup && dispatch(showLogoutNotificationPopupAction({
                                isLoginAgainPopup,
                                onAccept: () => showLoginPopup()
                            }));
                        }
                    },
                    {
                        text: translate('cancel.button.title'),
                        className: 'fn-decline fn-popup-decline popup-modal__button_type_accept',
                        onClick: () => {
                            closePopups('logout');
                        }
                    }
                ],
                /* TotalCasino changes */
                isModal: false,
                className: 'logout-confirm-popup'
            });
        };

        dispatcher.listen('auth:action:logout', invokeLogoutConfirmation);

        return () => {
            dispatcher.removeListener('auth:action:logout', invokeLogoutConfirmation);
        };
    }, [
        dispatch,
        closePopups,
        isLoginAgainPopup,
        showLoginPopup,
        translate,
        logout,
        showConfirmationPopup
    ]);
};
